<wa-card>
  <div class="wa-stack">
    <div><h5>{{ staffmember.last_name }}, {{staffmember.first_name }}</h5></div>
    <div class="wa-split wa-align-items-start wa-gap-xl">
      <div class="wa-stack">
        <div>{{ staffmember.email }}</div>
        <div class="wa-cluster">
          <wa-icon variant="solid" name="house"></wa-icon>
          @if (!staffmember.units.length) {
            <span>???</span>
          } @else {
          @for (unit of staffmember.units; track unit.id) {
            <span>{{ unit.name }}</span>
            @if (!$last) {
              <span>, </span>
            }
          }
        }
        </div>
      </div>
      <div class="wa-stack">
        @for(contract of staffmember.contracts; track contract.id) {
          <div class="wa-cluster">
            <wa-icon variant="solid" name="briefcase"></wa-icon>
            <span>{{ contract.begin | date: dateFormat }}-{{ contract.end | date: dateFormat }}</span> ({{ contract.required_supervisions }} / {{ contract.required_corrections }} )
          </div>
        }
      </div>
      <div class="wa-stack" >
        <div class="wa-cluster">
          <wa-icon variant="solid" name="person-chalkboard"></wa-icon>
          <span>supervision: {{ staffmember.required_supervisions }}</span>
        </div>
        <div class="wa-cluster">
          <wa-icon variant="solid" name="pen-nib"></wa-icon>
          <span>grading: {{ staffmember.required_corrections }}</span>
        </div>
      </div>
    </div>
    <div class="wa-cluster wa-gap-xs wa-justify-content-end">
      @if(showSupervisionGradingControls()) {
        <wa-button size="s" variant="neutral" appearance="filled" (click)="displayAssignments.emit(staffmember)"><wa-icon slot="end" name="list" label="display assignments"></wa-icon>show assignments</wa-button>
        <!--wa-button size="s" variant="neutral" appearance="filled" (click)="editSupervisions.emit(staffmember)"><wa-icon slot="end" name="person-chalkboard" label="edit supervision"></wa-icon>supervision</wa-button-->
        <!--wa-button size="s" variant="neutral" appearance="filled" (click)="editCorrections.emit(staffmember)"><wa-icon slot="end" name="pen-nib" label="edit corrections"></wa-icon>grading</wa-button-->
      }
    </div>
  </div>
</wa-card>
